import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: James Coyle
 * id E27EBD86-D80B-473B-BEAB-A22005475F38
 * name bottle-wine
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-wine.svg
 * tags
 * - Food / Drink 
 */
export const BottleWineIcon = createSvgIcon(<><path d="M10,22A1,1 0 0,1 9,21V11C9,9 10,7.25 11,7V2.5A0.5,0.5 0 0,1 11.5,2H12.5A0.5,0.5 0 0,1 13,2.5V7C14,7.25 15,9 15,11V21A1,1 0 0,1 14,22H10Z" /></>, 'BottleWineIcon');
export default BottleWineIcon